<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Insurance Agency",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Insurance Agency",
            items: [
               {
                  text: "Insurance Agencies",
                  href: "/insurance-agencies",
               },
               {
                  text: "Edit",
                  active: true,
               },        
            ],

            agency: {},
            token: '',
            country_code: '91',
            errors: {},
            loading: false,

            states: [],
            districts: [],

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchStates();
         this.fetchAgency();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         fetchAgency() {
            let url = "api/hub/agencies/get?agency_id="  + this.$route.params.id;

            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.agency = responseData.agency;
                  this.fetchDistricts();
                  
               })
            .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },      

         fetchStates() {
            let url = "/api/hub/agencies/getStates";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.states = responseData.states;

               })
               .catch((err) => console.log(err));
         },

         fetchDistricts() {
            let url = "/api/hub/agencies/getDistricts?state_id=" + this.agency.state_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.districts = responseData.districts;
               })
               .catch((err) => console.log(err));
         },  

         updateAgency() {
            this.getToken();
            
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var data = JSON.stringify({
               "id": this.agency.id,
               "agency_name": this.agency.agency,
               "agency_place": this.agency.agency_place,
               "state_id": this.agency.state_id,
               "district_id": this.agency.district_id,
               "agency_address": this.agency.agency_address,
               "agency_email": this.agency.agency_email,
               "agency_mobile": this.agency.agency_mobile
            });
            this.loading = true;            
            
            this.$axios
               .put("/api/hub/agencies/update", data, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: "agencies" });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },   

      },

   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <!-- <router-link :to="{ name: 'agencies' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updateAgency">
                        <div class="row"> 

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Agency Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="agency.agency" v-bind:class="{ 'is-invalid': Boolean(errors.agency_name) }" maxlength="100"></b-form-input>

                              <div v-for="(val, index) in errors.agency_name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Address</label>
                              <b-form-input v-model="agency.agency_address" v-bind:class="{ 'is-invalid': Boolean(errors.agency_address) }" maxlength="100"></b-form-input>

                              <div v-for="(val, index) in errors.agency_address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Place</label>
                              <b-form-input v-model="agency.agency_place" v-bind:class="{ 'is-invalid': Boolean(errors.agency_place) }" maxlength="50"></b-form-input>
                              <div v-for="(val, index) in errors.agency_place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group prepend="+91">
                                 <b-form-input v-model="agency.agency_mobile" v-bind:class="{ 'is-invalid': Boolean(errors.agency_mobile) }" maxlength="10" @keypress="numbersOnly"></b-form-input>
                              </b-input-group>

                              <div v-for="(val, index) in errors.agency_mobile" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Email</label>
                              <b-form-input type="email" v-model="agency.agency_email" v-bind:class="{ 'is-invalid': Boolean(errors.agency_email) }" maxlength="100"></b-form-input>

                              <div v-for="(val, index) in errors.agency_email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>State <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="agency.state_id" v-bind:class="{ 'is-invalid': Boolean(errors.state_id) }" @change="fetchDistricts(), agency.district_id = ''">
                                 <option :value="state.id" v-for="state in states" :key="state.id">{{state.state}}</option>
                              </select>
                              <div v-for="(val, index) in errors.state_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3" v-if="agency.state_id">
                              <label>District <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="agency.district_id" v-bind:class="{ 'is-invalid': Boolean(errors.district_id) }">
                                 <option value="" v-if="agency.district_id==''">Select District</option>
                                 <option :value="district.id" v-for="district in districts" :key="district.id">{{district.district}}</option>
                              </select>
                              <div v-for="(val, index) in errors.district_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <!-- <router-link :to="{ name: 'agencies' }" class="btn btn-light">Cancel</router-link> -->
                              <a href="#" @click.prevent="$router.go(-1)" class="btn btn-light">Cancel</a>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
